import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SeasonLink as Link } from '../../components/Seasons/SeasonLink';
import { confirmSfeduLink, getPendingSfeduLink } from '../../api/auth';
import { useAuth } from '../../context/AuthContext';

export function SfeduLinkConfirmation() {
  const [candidate, setCandidate] = useState(null);
  const [password, setPassword] = useState('');
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { refreshSession } = useAuth();

  useEffect(() => {
    let active = true;
    getPendingSfeduLink().then(value => { if (active) setCandidate(value); })
      .catch(err => { if (active) setError(err.message || 'Начните вход через ЮФУ заново.'); });
    return () => { active = false; };
  }, []);

  const submit = async event => {
    event.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await confirmSfeduLink(password);
      setPassword('');
      await refreshSession();
      navigate('/my-season', { replace: true });
    } catch (err) {
      setError(err.message || 'Не удалось подключить ЮФУ. Попробуйте ещё раз.');
    } finally {
      setBusy(false);
    }
  };

  return <div className="auth-container">
    <div className="auth-form-container auth-form-container-full">
      <div className="auth-card auth-card-compact auth-link-confirmation">
        <h1 className="auth-title auth-title-primary">Сохраним ваш аккаунт</h1>
        {candidate ? <>
          <p className="auth-intro">На ЮФУ.Про уже есть профиль с почтой <span className="auth-account-hint">{candidate.email_hint}</span>.
            {' '}Подключим к нему вход через ЮФУ. Ваши команды, баллы и история сохранятся.</p>
          {candidate.password_available ? <form className="auth-form" onSubmit={submit}>
            <div className="form-group">
              <label className="form-label" htmlFor="sfedu-existing-password">Пароль от аккаунта ЮФУ.Про</label>
              <div className="password-input-wrapper">
                <input id="sfedu-existing-password" className="form-input" type={visible ? 'text' : 'password'}
                  autoComplete="current-password" required minLength={8} maxLength={128}
                  value={password} onChange={event => setPassword(event.target.value)} aria-describedby="sfedu-password-help" />
                <button type="button" className="password-toggle" onClick={() => setVisible(value => !value)}
                  aria-label={visible ? 'Скрыть пароль' : 'Показать пароль'}>{visible ? 'Скрыть' : 'Показать'}</button>
              </div>
              <p id="sfedu-password-help" className="sfedu-sign-in-hint">Тот пароль, который вы создавали на этом сайте. Подтверждение понадобится один раз.</p>
            </div>
            <button className="auth-button" disabled={busy}>{busy ? 'Подключаем…' : 'Подключить ЮФУ и войти'}</button>
            <Link to="/forgot-password" className="auth-link-register">Не помню пароль ЮФУ.Про</Link>
          </form> : <p className="auth-intro">У этого аккаунта нет пароля. Войдите прежним способом, например через Leader-ID, и подключите ЮФУ в настройках.</p>}
        </> : !error && <p role="status" className="auth-intro">Находим ваш профиль…</p>}
        {error && <p className="auth-link auth-link-error" role="alert">{error}</p>}
        <p className="auth-link"><Link to="/login?method=password" className="auth-link-register">Другой способ входа</Link></p>
      </div>
    </div>
  </div>;
}
